function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M5.962,8.612a9.679,9.679,0,0,1,3.72,1.631,3.7,3.7,0,0,1,1.376,3.109,3.372,3.372,0,0,1-1.045,2.6,5.3,5.3,0,0,1-2.727,1.274v2.344H4.026V17.225A5.535,5.535,0,0,1,1.2,15.8,4.042,4.042,0,0,1,0,13.046H2.395q.2,2.293,3.261,2.293A3.279,3.279,0,0,0,7.9,14.727,1.792,1.792,0,0,0,8.561,13.4a2.064,2.064,0,0,0-.688-1.529A5.815,5.815,0,0,0,5.3,10.752Q.2,9.529.2,6.268a3.4,3.4,0,0,1,1.07-2.523,5.454,5.454,0,0,1,2.752-1.4V0H7.287V2.395A4.5,4.5,0,0,1,9.81,3.924a4.3,4.3,0,0,1,.943,2.6H8.357q-.1-2.293-2.7-2.293a3.684,3.684,0,0,0-2.166.56A1.731,1.731,0,0,0,2.7,6.268a1.583,1.583,0,0,0,.714,1.3A8.207,8.207,0,0,0,5.963,8.612Z",
  fill: "#d6d6d6"
});

var SvgPayments = function SvgPayments(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11.058,
    height: 19.569,
    viewBox: "0 0 11.058 19.569",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPayments, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/payments.fad8432d.svg";
export { ForwardRef as ReactComponent };